import React from 'react';
import { formatRawMoney } from '@lialo/common/lib/formatter/money';
import { DiscountCodeInfo } from '../../common/models/code-info';
import { useShowSnackbar } from '../../components/GlobalSnackbar';
import { Price } from './models';

export function usePrice(price: string) {
  const [currentPrice, setCurrentPrice] = React.useState<Price>({ currentPrice: price });
  const showSnackbar = useShowSnackbar();

  const applyDiscount = (discountCodeInfo: DiscountCodeInfo) => {
    const reducedPrice = formatRawMoney(parseFloat(price) * (1 - discountCodeInfo.discount));
    setCurrentPrice({
      currentPrice: reducedPrice,
      appliedDiscount: {
        reducedPrice,
        code: discountCodeInfo.code,
      },
    });

    showSnackbar({
      key: 'checkout.coupon.discount_applied',
      params: { discount: discountCodeInfo.discount * 100 },
    });
  };

  const clearDiscount = () => {
    setCurrentPrice({ currentPrice: price });
  };

  return { applyDiscount, clearDiscount, currentPrice } as const;
}
